import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import { ff } from '../../../theme';
import { stickyCtaBottomOffset } from '../theme';

type Scrim = 'white' | 'v2';

type Props = {
  children: React.ReactNode;
  /** Kept for existing callers; both render the board's white bar with a hairline top border. */
  scrim?: Scrim;
  /** Match parent page horizontal padding (Chakra spacing scale). */
  px?: number;
};

/** Mobile-first footer — fixed above the floating tab bar; flows inline on md+. */
const StickyBottomCta: React.FC<Props> = ({ children, px }) => (
  <Box
    position={{ base: 'fixed', md: 'static' }}
    bottom={{ base: stickyCtaBottomOffset, md: 'auto' }}
    left={{ base: 0, md: 'auto' }}
    right={{ base: 0, md: 'auto' }}
    zIndex={{ base: 10, md: 'auto' }}
    px={{ base: px ?? '20px', md: 0 }}
    bg="white"
    borderTop={{ base: '1px solid', md: 'none' }}
    borderColor={ff.line}
    pt={{ base: '14px', md: 0 }}
    mt={{ base: 0, md: '16px' }}
    pb={{ base: '28px', md: 0 }}
  >
    <VStack spacing="12px" align="stretch">
      {children}
    </VStack>
  </Box>
);

export default StickyBottomCta;
